export const volumeFormatter = (volume?: number): string => {
  return `${volume}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function areEquals(a?: number, b?: number): boolean {
  if (a === undefined && b === undefined) return true;
  if (a === undefined || b === undefined) return false;

  // Son igual si los primeros dos decimales coinciden
  return Math.abs(a - b) < 0.005;
}

export const arraysAreEqual = (a: string[], b: string[]) =>
  a.length === b.length && a.every((v, i) => v === b[i]);

/***
 * Regresa el color del cual se pintara el procentaje
 * El porcentaje se pinta (solo el porcentaje) con estas reglas:
 ** si el porcentaje es menor o igual a 1% se muestra en color normal
 ** si el porcentaje es mayor a 1% y menor o igual a 3% se muestra en color naranja
 ** si el porcentaje es mayor a 3% se muestra en color rojo
 */
function percentageColor(pct: number | undefined): string {
  if (pct === undefined) return "inherit";
  const abs = Math.abs(pct);
  if (abs > 3) return "#cf1322";
  if (abs > 1) return "#d46b08";
  return "inherit";
}

export function differenceFormatter(diff?: number, percentage?: number) {
  if (diff === undefined && percentage === undefined) return "-";
  const pctAbs = percentage !== undefined ? Math.abs(percentage) : undefined;
  const pctStr = pctAbs !== undefined ? pctAbs.toFixed(2) + "%" : undefined;

  return (
    <span>
      {volumeFormatter(diff)}
      {" ("}
      {pctStr && (
        <span style={{ color: percentageColor(percentage) }}>{pctStr}</span>
      )}
      {")"}
    </span>
  );
}
